<template>
  <div class="iframe-container">
    <iframe
      :src="xpathUrl"    
      width="100%"
      height="100%"
      frameborder="0"               
      sandbox="allow-scripts allow-same-origin"          
    ></iframe>
    <div v-if="loading" class="loading-mask">       
      <el-icon class="loading icon"><loading /></el-icon>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            // xpathUrl: 'http://data-platform-frontend.k8s.local/',
            xpathUrl: 'http://192.168.1.7:8080/',
            loading: true
        }
    },
    mounted(){
        const iframe = this.$el.querySelector('iframe')   //获取iframe DOM元素
        iframe.onload = () => {
            this.loading = false    //关闭加载动画
            this.$nextTick(() => {
                iframe.style.height = iframe.contentWindow.document.body.scrollHeight + 'px'
            })
        }
    }
    // iframe.onerror = () =>{
    //     this.loading = false
    //     this.$message.error('页面加载失败')
    // }
}
</script>

<style scoped>
.iframe-container{
    position: relative;
    height: calc(100vh - 84px);
}

.loading-mask{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
}

.loding-icon{
    font-size: 40px;

}

</style>
